// src/utils/logger.js

// Setting this to false disables all logger output.
// It must stay false for production builds.
const DEBUG_ENABLED = process.env.REACT_APP_ENABLE_DEBUG_LOGGING === 'true';

const getTime = () => new Date().toLocaleTimeString();

// Do NOT log full request/response bodies containing sensitive data
// (auth tokens, donor emails, financial amounts) at info/warn level by default.
// Only include non-sensitive metadata unless explicitly extending later.
export const logger = {
  info: (scope, message, data) => {
    if (!DEBUG_ENABLED) return;
    const prefix = `[z.Bookkeeping][INFO][${scope}] ${getTime()}`;
    if (data) {
      console.info(prefix, message, data);
    } else {
      console.info(prefix, message);
    }
  },
  warn: (scope, message, data) => {
    if (!DEBUG_ENABLED) return;
    const prefix = `[z.Bookkeeping][WARN][${scope}] ${getTime()}`;
    if (data) {
      console.warn(prefix, message, data);
    } else {
      console.warn(prefix, message);
    }
  },
  error: (scope, message, data) => {
    if (!DEBUG_ENABLED) return;
    const prefix = `[z.Bookkeeping][ERROR][${scope}] ${getTime()}`;
    if (data) {
      console.error(prefix, message, data);
    } else {
      console.error(prefix, message);
    }
  },
  network: (scope, message, data) => {
    if (!DEBUG_ENABLED) return;
    const prefix = `[z.Bookkeeping][NETWORK][${scope}] ${getTime()}`;
    if (data) {
      console.error(prefix, message, data);
    } else {
      console.error(prefix, message);
    }
  },
};

export const getErrorMessage = (err, defaultMessage = 'An error occurred.') => {
  if (!err) return defaultMessage;
  if (err.non_field_errors?.[0]) return err.non_field_errors[0];
  if (err.detail) return err.detail;
  if (err.error) return err.error;

  // Find the first field that has an array of strings (standard DRF format)
  const fieldErrorKey = Object.keys(err).find(key => Array.isArray(err[key]) && typeof err[key][0] === 'string');
  if (fieldErrorKey) {
    return err[fieldErrorKey][0];
  }
  return defaultMessage;
};
